function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.5 61.2812V1.25387H0.5V61.2812H60.5Z",
  fill: "white",
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_64_272)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.43442 48.0975L1.19531 55.3398C4.14309 58.2529 8.8887 58.2384 11.8186 55.3071L18.5313 48.5914",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.4902 30.7891C55.3653 28.3825 55.8427 25.7848 55.8427 23.0755V13.8419C55.8427 8.96986 51.895 5.02037 47.0251 5.02037C45.8671 5.02036 44.7205 5.24855 43.6506 5.69189C42.5808 6.13524 41.6087 6.78506 40.7899 7.60426L32.0312 16.3682",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.293 45.6353C39.1952 45.6354 44.5678 43.3668 48.5872 39.6536",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.7812 12.8131L59.7999 16.8374H56.2938",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.0313 16.3674L2.78516 45.6267C12.2883 51.0494 24.2691 49.4167 32.005 41.6773C38.9838 34.6955 39.0101 23.3493 32.0313 16.3674Z",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.14453 42.2246C12.9031 42.6199 19.7366 40.1541 24.7629 35.1256C29.1979 30.6886 30.8407 24.4734 29.6388 18.7593",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.8281 45.6353H59.8003",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.5117 45.6303L45.5535 50.6792",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.5547 52.5862V50.6791H47.4609C50.1588 50.6791 52.3457 52.867 52.3457 55.566V57.4731H50.4395C47.7416 57.4731 45.5547 55.2852 45.5547 52.5862Z",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 12,
  r: 1,
  fill: "black"
}));

function SvgBirds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_272",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 62
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirds);
export default __webpack_public_path__ + "static/media/birds.e15f46928da568ea13b8a49974b7b1fb.svg";
export { ForwardRef as ReactComponent };